// components/chat/chat-input/LexicalComposerConfig.ts
import { InitialConfigType } from "@lexical/react/LexicalComposer";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { ListNode, ListItemNode } from "@lexical/list";
import { CodeNode } from "@lexical/code";
import { LinkNode } from "@lexical/link";
import { MentionNode } from "./MentionNode";

export const lexicalConfig: InitialConfigType = {
  namespace: "shattara-chat-input",
  editable: true,
  onError(error) {
    console.error("Lexical Error:", error);
  },
  theme: {
    paragraph: "m-0",
  },
  nodes: [
    HeadingNode,
    QuoteNode,
    ListNode,
    ListItemNode,
    CodeNode,
    LinkNode,
    MentionNode,
  ],
};
